import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType, Request, RequestOptions, RequestOptionsArgs } from "@angular/http";
import "rxjs/add/operator/map";
import 'rxjs/Rx';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { ViajeReciboConforme } from '../Models/ViajeReciboConforme';
import { VisitaReciboConforme } from '../Models/VisitaReciboConforme';
import { ArrayBuffer } from '@angular/http/src/static_request';
import { ReportePagosEfectuados } from '../Models/ReportePagosEfectuados';
import { Resultado } from '../Models/Resultado';

@Injectable()
export class GeneradorTemplateService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }





  ReporteViajeReciboConforme(compania: string, idViaje: string,nombreArchivo: String): Observable<Resultado> {

    try {

      let url = this._utiles.getURL("GeneradorTemplate/generarReporteViajeRecibo/" + compania + '/' + idViaje + '/' +nombreArchivo);


     
    return this._http.get(url).map((response: Response) => {
      return <Resultado>response.json();
    });



    } catch (error) {

      console.log(error);
    }



  }


  ReporteCertificacionEntrega(compania: string, idViaje: string, idVisita: string): Observable<any> {

    try {

      let url = this._utiles.getURL("GeneradorTemplate/generarReporteCertificacion/" + compania + '/' + idViaje + '/' + idVisita);


      return this._http.get(url).map((response: Response) => {
        return <any>response.blob();
      });



    } catch (error) {

      console.log(error);
    }

  }





  downloadPDF(compania: string, idViaje: string, idVisita: string, nombreArchivo: string): Observable<Resultado> {

    let url = this._utiles.getURL("GeneradorTemplate/generarReporteCertificacion/" + compania + '/' + idViaje + '/' + idVisita + '/' + nombreArchivo);

    return this._http.get(url).map((response: Response) => {
      return <Resultado>response.json();
    });
  }


  ReporteFacturacion(compania: string, numeroDocumento: string,nombreArchivo: string): Observable<Resultado> {

    let url = this._utiles.getURL("GeneradorTemplate/generarReporteFacturacion/" + compania + '/' + numeroDocumento + '/'+ nombreArchivo);

    return this._http.get(url).map((response: Response) => {
      return <Resultado>response.json();
    });
  }


  ReporteViaje(compania: string, idViaje: string,idVisita: string, nombreArchivo: string): Observable<Resultado> {

    let url = this._utiles.getURL("GeneradorTemplate/generarReporteViaje/" + compania + '/' + idViaje + '/'+ idVisita+ '/'+ nombreArchivo );

    return this._http.get(url).map((response: Response) => {
      return <Resultado>response.json();
    });


  }

  ReporteEtiquetaContenedor(compania: string, etiquetaContenedor: string, nombreArchivo: string): Observable<Resultado> {

    let url = this._utiles.getURL("GeneradorTemplate/generarReporteEtiquetaContenedor/" + compania + '/' + etiquetaContenedor + '/'+ nombreArchivo);

    return this._http.get(url).map((response: Response) => {
      return <Resultado>response.json();
    });
  }


  /**
   * Gnera el reporte de pagos, liquidacion de valores
   * @param compania 
   * @param idviaje 
   * @param nombreArchivo 
   */
  ReportePago(compania: string, idviaje: string, nombreArchivo: string): Observable<Resultado> {

    let url = this._utiles.getURL("GeneradorTemplate/generarReportePago/" + compania + '/' + idviaje + '/'+ nombreArchivo);

    return this._http.get(url).map((response: Response) => {
      return <Resultado>response.json();
    });
  }

  GeneradoExcel(compania: string, lista: ReportePagosEfectuados[]): any {

    try {

      const obj={
        compania: compania,
        pagos: lista
      };

      let params = JSON.stringify(obj);

      let url = this._utiles.getURL("GeneradorExcel/GenerarExcel/");

      let headers = new Headers({ 'Content-Type': 'application/json' });

      let data: any;


      return this._http.post(url, obj, { headers: headers }).map(res => res.json());


    } catch (error) {
      console.log(error);
    }


  }


}

